export const DEFAULT_OPTIONS = {
	preloadMaxAge: 2000,
	timeToIntent: 200,
};
